import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://amwapservices.com";

export const Canonical = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const url = SITE + (pathname.replace(/\/+$/, "") || "/");
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
    const og = document.querySelector('meta[property="og:url"]');
    if (og) og.content = url;
  }, [pathname]);
  return null;
};
